<script>
import messages from '../fr/messages.vue';
import labels from '../fr/labels.vue';
import text from '../fr/text.vue';
import app from '../fr/app.vue';

export default 
  {
    messages: messages,
    labels: labels,
    text: text,
    app: app
  }
</script>
